import { User } from 'configcat-react';

import useConfig from '@/hooks/useConfig.ts';

export const useConfigCatUser = (): User | undefined => {
    const { customer_id: customerId, selected_location: selectedLocation } = useConfig();

    if (customerId === '') return undefined;

    return new User(customerId, undefined, undefined, {
        locationId: selectedLocation?.id ?? '',
    });
};
